<div class="row mt-3">
  <div class="col-12">
    <lib-gung-tabset justify="fill">
      <lib-gung-tab id="new-user">
        <ng-template libGungTabTitle>
          <div class="request-account-tab-title">{{ 'NEW_USER' | translate }}</div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="pt-3">
            <ng-template
              [libCustomHostDynamic]="userFormComponent"
              [inputs]="{}"
              [outputs]="{ returnToLogin: returnToLoginFn.bind(this) }"
            ></ng-template>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="new-customer">  
        <ng-template libGungTabTitle>
          <div class="request-account-tab-title">{{ 'NEW_CUSTOMER' | translate }}</div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="pt-3">
            <ng-template
              [libCustomHostDynamic]="customerFormComponent"
              [inputs]="{}"
              [outputs]="{ returnToLogin: returnToLoginFn.bind(this) }"
            ></ng-template>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
</div>
